import { render, staticRenderFns } from "./VideoBottomBar.vue?vue&type=template&id=04549770&scoped=true"
import script from "./VideoBottomBar.vue?vue&type=script&lang=js"
export * from "./VideoBottomBar.vue?vue&type=script&lang=js"
import style0 from "./VideoBottomBar.vue?vue&type=style&index=0&id=04549770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04549770",
  null
  
)

export default component.exports